import script from "./CompanyRoleSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyRoleSelectionModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyRoleSelectionModal.vue?vue&type=style&index=0&id=40f85ae3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f85ae3"]])

export default __exports__